import { DOMRouteHandler } from '../util/Router';
import { initDatabasePageTemplate } from '../modules/database';

export class PageTemplateTempDatabase extends DOMRouteHandler {
  static init(): void {
    initDatabasePageTemplate();
  }
}
